import { withFormsy } from 'formsy-react'
import React from 'react'
import TranslationPreview from 'app/main/messages/notificationTimeline/notification-preview/TranslationPreview'

const FormsyTranslationPreview = (props) => {
  // setValue() will set the value of the component which allow Formsy to receive the value
  const { setValue, ...rest } = props
  return <TranslationPreview {...rest} onTranslateChange={setValue} />
}

export default withFormsy(FormsyTranslationPreview)
